import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface ConfirmationDialog {
  title: string;
  message: string;
  yes: string;
  no: string;
}

@Component({
  selector: 'app-confirmation-message',
  templateUrl: './confirmation-message.component.html',
  styleUrls: ['./confirmation-message.component.scss']
})
export class ConfirmationMessageComponent implements OnInit {

  dialogData :ConfirmationDialog = {
    title : '',
    message: '',
    yes: 'Yes',
    no: 'No',
  };
 constructor(
   public dialogRef: MatDialogRef<ConfirmationMessageComponent>,
   @Inject(MAT_DIALOG_DATA) public data :ConfirmationDialog
 ) {
   if(data) {
     this.dialogData = data
   }
  }

 ngOnInit(): void {
 }
 dialogClose(value:any) {
   this.dialogRef.close(value);
 }

}
